import React, { useContext } from 'react';
import { Col, Row } from 'antd';

import Grade from '@totem/components/common/Grade';
import RegionDetailsContext from '@totem/components/portfolio/regions/details/RegionDetailsContext';
import IBStatistic from '@totem/components/ui_components/widgets/statistic/IBStatistic';
import { isNotNull } from '@totem/utilities/common';

const RegionDetailsKPIs = () => {
  const { region, loading } = useContext(RegionDetailsContext);

  const hasScore =
    isNotNull(region) &&
    isNotNull(region.policyAudits) &&
    region.policyAudits.count > 0 &&
    region.policyAudits.maxScore > 0;

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: '1rem' }}>
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <IBStatistic
          title="Buildings"
          subTitle={<span>&nbsp;</span>}
          value={isNotNull(region) ? region.buildings : loading ? '' : 0}
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <IBStatistic
          title="Control Systems"
          subTitle={<span>&nbsp;</span>}
          value={isNotNull(region) ? region.controlSystems : loading ? '' : 0}
        />
      </Col>
      <Col xs={24} sm={12} md={8} lg={6} xl={4}>
        <IBStatistic
          title="Audit Score"
          subTitle={<span>&nbsp;</span>}
          value={
            hasScore ? (
              <Grade
                score={
                  (region.policyAudits.totalScore /
                    region.policyAudits.maxScore) *
                  100
                }
                size="extraLarge"
              />
            ) : (
              'N/A'
            )
          }
        />
      </Col>
    </Row>
  );
};

export default RegionDetailsKPIs;
